var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bb-alert-container" },
    [
      _vm._l(_vm.successMessages, function (message, index) {
        return _c(
          "div",
          {
            key: index,
            ref: "success-" + index,
            refInFor: true,
            staticClass: "bb-alert success",
          },
          [
            _c(
              "button",
              {
                on: {
                  click: function ($event) {
                    return _vm.hideSuccessMessage(index)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "feather feather-check-circle",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "37",
                      height: "37",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("path", {
                      attrs: { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" },
                    }),
                    _c("polyline", {
                      attrs: { points: "22 4 12 14.01 9 11.01" },
                    }),
                  ]
                ),
              ]
            ),
            _c("span", [_vm._v(_vm._s(message))]),
          ]
        )
      }),
      _vm._l(_vm.errorMessages, function (message, index) {
        return _c(
          "div",
          {
            key: index,
            ref: "error-" + index,
            refInFor: true,
            staticClass: "bb-alert danger",
          },
          [
            _c(
              "button",
              {
                on: {
                  click: function ($event) {
                    return _vm.hideErrorMessage(index)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "feather feather-x-circle",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "37",
                      height: "37",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
                    _c("line", {
                      attrs: { x1: "15", y1: "9", x2: "9", y2: "15" },
                    }),
                    _c("line", {
                      attrs: { x1: "9", y1: "9", x2: "15", y2: "15" },
                    }),
                  ]
                ),
              ]
            ),
            message === "The given data was invalid." &&
            _vm.activeLanguage() !== "en"
              ? _c("span", [_vm._v(" Došlo je do greške ")])
              : _c("span", [_vm._v(_vm._s(message))]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }